import styled from "styled-components";
import { Button as themeButton } from 'theme-ui';

interface CustomProps {
  $iconHeight?: string;
  $iconWidth?: string;
}

export const Button = styled(themeButton)<CustomProps>`    
  & svg {
    height: ${(props) => props.$iconHeight || "12px"};
    width: ${(props) => props.$iconWidth || "12px"};
    margin-right: 10px;
  }
`;